import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { getDocsbyIDList } from '@store/firebase/series/get-series';
import { IpostingItem } from '@typings/posting/posting.interface';
import { IseriesItem } from '@typings/posting/series.interface';
import { getPathKey } from '@utils/getPath';
import CollapseBtn from '@components/dataEntry/button/CollapseBtn/CollapseBtn';
import Icon from '@components/dataDisplay/Icons/Icon';
import IconButton from '@components/dataEntry/button/IconButton';

const SeriesHeader = styled.div<{
  active: boolean;
}>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border-radius: var(--buttonBorderRadius);
  padding: 4px;

  ${({ active }) =>
    active && {
      backgroundColor: 'var(--buttonBackgroundColor)',
      color: 'var(--buttonTextColor)',
    }}

  .counter {
    font-size: 16px;
    color: var(--subTextColor);
  }
`;

const activeStyle = css`
  font-weight: 800;
  text-decoration: underline;
  .number {
    color: var(--primaryColor);
  }
`;

const Item = styled.div<{
  active: boolean;
}>`
  padding: 3px 4px;
  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    font-weight: 800;
  }

  .number {
    color: var(--subTextColor);
    margin-right: 8px;
  }

  ${({ active }) => active && activeStyle}
`;

type Props = {
  setDocId: any;
  seriesData: IseriesItem;
  isActive: boolean;
};
function SeriesItem({ seriesData, setDocId, isActive }: Props) {
  const collectionPath = getPathKey(1);
  const docId = getPathKey(2);
  const navigate = useNavigate();

  const [seriesList, setSeriesList] = useState<IpostingItem[]>([]);
  const [collapse, setCollapse] = useState<boolean>(isActive);

  useEffect(() => {
    const fetchData = async () => {
      if (
        seriesData &&
        seriesData.postingList &&
        seriesData.postingList.length > 0
      ) {
        const res = await getDocsbyIDList({
          collectionPath,
          idList: seriesData.postingList,
        });
        setSeriesList(res);
      }
    };

    fetchData();
  }, [seriesData, collectionPath]);

  return (
    <>
      <SeriesHeader active={isActive}>
        <CollapseBtn
          onClick={() => setCollapse((prev) => !prev)}
          visible
          type="text"
          style={{ marginTop: 0 }}
          activeIcon={<Icon name="SeriesF" />}
          active={isActive}
        >
          <>
            <p>{seriesData.value}</p>
            <span className="counter">
              (<span>{seriesData.postingList?.length || 0}</span>)
            </span>
          </>
        </CollapseBtn>
        <IconButton
          icon={'Wheel18'}
          iconColor="var(--subTextColor)"
          size="sm"
          shape="default"
          onClick={() => navigate(`/series/${collectionPath}/${seriesData.id}`)}
        />
      </SeriesHeader>
      {collapse && (
        <>
          {seriesList.map((list, i) => {
            return (
              <Link to={`/${collectionPath}/${list.id}`} key={list.id}>
                <Item
                  onClick={() => setDocId(list.id)}
                  active={list.id === docId}
                >
                  <span className="number">{i + 1}</span>
                  {list.title}
                </Item>
              </Link>
            );
          })}
        </>
      )}
    </>
  );
}

export default React.memo(SeriesItem);
